import React, { FC, useEffect } from 'react'
import s from './Products.module.scss'
import TopBanner from '../../components/TopBanner/TopBanner'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import { NavLink } from 'react-router-dom'
import CardProduct from '../../components/CardProduct/CardProduct'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { scrollToTop } from '../../utils'
import { fetchByProducts } from '../../store/slices/productsSlice'
import Loader from '../../components/Loader/Loader'
import { Helmet } from 'react-helmet-async'

const Products: FC = () => {
    const { products, loading } = useAppSelector(state => state.products)
    const dispatch = useAppDispatch()

    useEffect(() => {
        scrollToTop()
        dispatch(fetchByProducts())
    }, [dispatch])

    return (
        <>
            <Helmet>
                <meta property="og:title" content="Продукция | Автоматизация технологических процессов и производств | Phoenix Programs" />
                <meta property="og:description" content="Ознакомьтесь с нашей продукцией - передовые решения в автоматизации и различных отраслях." />
                <meta name="twitter:title" content="Продукция | Автоматизация технологических процессов и производств | Phoenix Programs" />
                <meta name="twitter:description" content="Ознакомьтесь с нашей продукцией - передовые решения в автоматизации и различных отраслях." />
                <link rel="canonical" href="https://phoenix-programs.com/products" />
                <title>Продукция | Автоматизация технологических процессов и производств | Phoenix Programs</title>
            </Helmet>
            {loading && <Loader />}
            <TopBanner title='Продукция' />
            <Breadcrumbs>
                <NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/'} >Главная</NavLink>
                /
                <NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/products'} >Продукция</NavLink>
            </Breadcrumbs>
            <section className={s.section}>
                <div className={`${s.wrapper} container`}>
                    {
                        products?.map((el) => (
                            <CardProduct key={el.id} data={el} />
                        ))
                    }
                </div>
            </section>
        </>
    )
}

export default Products

